import React, { useState } from 'react';
import { Modal, Spin } from 'antd';
import { updateCommunityResource } from '../../../services/communityService';
import CommunityResourceForm from './CommunityResourceForm';

const EditCommunityResource = ({
  communityResource,
  isOpen,
  onCancelModal
}) => {
  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'Idle mode.'
  });

  const onSubmit = async (values) => {
    setStatus({ type: 'LOADING', message: 'Is waiting for response' });
    await updateCommunityResource(values, communityResource._id)
      .then((res) => {
        setStatus({ type: 'SUCCESS', message: 'Successful response' });
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: err?.response?.data });
      });
  };
  return (
    <div>
      <Modal
        title={`Edit Community Event`}
        visible={isOpen}
        onCancel={() => onCancelModal()}
        footer={null}>
        {status.type === 'LOADING' ? (
          <Spin size="large" />
        ) : (
          <CommunityResourceForm
            initialValues={communityResource}
            setStatus={setStatus}
            status={status}
            type="Update"
            onSubmit={onSubmit}
          />
        )}
      </Modal>
    </div>
  );
};

export default EditCommunityResource;
